var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNouser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-icon--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.17,134.69,98.4,107.42l-.77-6.8c-.49-4.31-2.21-7.31-4.68-8.74l-6.57-3.79c-2.45-1.41-5.65-1.26-9.11.74L59.16,99.28c-6.94,4-12.81,14.21-13.79,23.92l-.77,7.7Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.17,134.69,98.4,107.42l-.77-6.8c-.49-4.31-2.21-7.31-4.68-8.74l-6.57-3.79c-2.45-1.41-5.65-1.26-9.11.74L59.16,99.28c-6.94,4-12.81,14.21-13.79,23.92l-.77,7.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63,100.62c-.49-4.31-2.21-7.31-4.68-8.74s-5.65-1.26-9.11.74L65.73,103.07c-6.94,4-12.82,14.21-13.79,23.93l-.77,7.69L98.4,107.42Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.63,100.62c-.49-4.31-2.21-7.31-4.68-8.74s-5.65-1.26-9.11.74L65.73,103.07c-6.94,4-12.82,14.21-13.79,23.93l-.77,7.69L98.4,107.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85,62.94c2.32,1.35,3.76,4.23,3.76,8.33,0,8.19-5.75,18.16-12.85,22.26-3.55,2-6.76,2.24-9.09.9L60.38,90.7c-2.33-1.34-3.77-4.22-3.77-8.32,0-8.2,5.76-18.16,12.86-22.26,3.54-2,6.76-2.24,9.08-.9Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,62.94c2.32,1.35,3.76,4.23,3.76,8.33,0,8.19-5.75,18.16-12.85,22.26-3.55,2-6.76,2.24-9.09.9L60.38,90.7c-2.33-1.34-3.77-4.22-3.77-8.32,0-8.2,5.76-18.16,12.86-22.26,3.54-2,6.76-2.24,9.08-.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.92,93.53c-3.55,2-6.76,2.24-9.09.9s-3.76-4.23-3.76-8.32c0-8.2,5.75-18.17,12.85-22.27,3.55-2,6.76-2.24,9.09-.9s3.76,4.23,3.76,8.33C88.77,79.46,83,89.43,75.92,93.53Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.92,93.53c-3.55,2-6.76,2.24-9.09.9s-3.76-4.23-3.76-8.32c0-8.2,5.75-18.17,12.85-22.27,3.55-2,6.76-2.24,9.09-.9s3.76,4.23,3.76,8.33C88.77,79.46,83,89.43,75.92,93.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.53,42.88a1.54,1.54,0,0,0-.05-.31.06.06,0,0,0,0-.07.94.94,0,0,0-.08-.31,1.35,1.35,0,0,0-.2-.44.72.72,0,0,0-.11-.19s-.06-.09-.11-.12a1,1,0,0,0-.22-.23l0,0a1.22,1.22,0,0,0-.29-.17,2.5,2.5,0,0,0-2.33.29L51.18,156.44c-1.91,1.1-3.47,3.79-3.47,7.65V358.26A2.35,2.35,0,0,0,49,360.34l.15.1.18.1a1,1,0,0,0,.29.1,1.74,1.74,0,0,0,.45.06,2.23,2.23,0,0,0,1.15-.33l.09-.05h0l3.31-1.91L251.09,245.19a7.65,7.65,0,0,0,3.47-6V43.32C254.56,43.17,254.54,43,254.53,42.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.63,41.84a.73.73,0,0,1,.38.09l.07,0,0,0,.06,0,.09.12h0v0l.07.11a.37.37,0,0,1,.07.14l0,0,.09.28v.06l0,0a.38.38,0,0,1,0,.1c0,.11,0,.23,0,.35V239.19a6.67,6.67,0,0,1-3,5.14L54.08,357.55l-3.21,1.85h0l-.09,0-.09.05a1.29,1.29,0,0,1-.65.2h0a.79.79,0,0,1-.23,0,.1.1,0,0,1-.07,0l-.09,0-.13-.09,0,0,0,0a1.36,1.36,0,0,1-.73-1.21v-1.75h0V164.09c0-3.74,1.53-6,3-6.79L251.58,42.18a2.25,2.25,0,0,1,1-.34m0-1a3.17,3.17,0,0,0-1.54.46L51.18,156.44c-1.91,1.1-3.47,3.79-3.47,7.65V357.5h0v.76A2.35,2.35,0,0,0,49,360.34l.15.1.18.1a1,1,0,0,0,.29.1,1.74,1.74,0,0,0,.45.06h0a2.23,2.23,0,0,0,1.1-.33l.09-.05h0l3.31-1.91L251.09,245.19a7.65,7.65,0,0,0,3.47-6V43.32c0-.15,0-.3,0-.44a1.54,1.54,0,0,0-.05-.31.06.06,0,0,0,0-.07.94.94,0,0,0-.08-.31,1.35,1.35,0,0,0-.2-.44.72.72,0,0,0-.11-.19s-.06-.09-.11-.12a1,1,0,0,0-.22-.23l0,0a1.22,1.22,0,0,0-.29-.17,1.9,1.9,0,0,0-.79-.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.42,41a2.5,2.5,0,0,0-2.33.29L51.18,156.44a7.66,7.66,0,0,0-3.47,6v6.72l-4.43-2.59v-6.64a7.67,7.67,0,0,1,3.46-6L246.66,38.81a2.41,2.41,0,0,1,2.52-.2C249.8,39,252.68,40.63,253.42,41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.55,43.29c0-2.19-1.56-3.07-3.46-2L51.17,156.44a7.65,7.65,0,0,0-3.46,6v6.72L254.55,50.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.63,41.79c.84,0,1,.94,1,1.5v6.22l-204.94,118v-5.09a6.72,6.72,0,0,1,3-5.18L251.56,42.14a2.2,2.2,0,0,1,1.07-.35m0-.94a3.12,3.12,0,0,0-1.54.47L51.17,156.44a7.65,7.65,0,0,0-3.46,6v6.72L254.55,50.06V43.29c0-1.55-.79-2.44-1.92-2.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.28,166.58v-6.66a7.07,7.07,0,0,1,1.06-3.46L48.75,159a6.94,6.94,0,0,0-1,3.44v6.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.5,51.42A3.53,3.53,0,0,0,238,54.23c0,1.08.66,1.58,1.47,1.11A3.51,3.51,0,0,0,241,52.53C241,51.45,240.32,51,239.5,51.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.8,48.36a3.52,3.52,0,0,0-1.47,2.81c0,1.08.66,1.58,1.47,1.11a3.53,3.53,0,0,0,1.47-2.81C246.27,48.39,245.61,47.89,244.8,48.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09,45.3a3.52,3.52,0,0,0-1.47,2.81c0,1.08.66,1.58,1.47,1.11a3.53,3.53,0,0,0,1.47-2.81C251.56,45.33,250.9,44.83,250.09,45.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,360.35l-.18-.1-3.65-2.11a3.67,3.67,0,0,1-1.81-2.68,4.36,4.36,0,0,1,0-.51V166.57l4.43,2.59V358.25a2.26,2.26,0,0,0,1.07,2l.12.08,0,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M69.63,167.29a.2.2,0,0,1,.27,0,.45.45,0,0,1,.12.35v8.8a12.64,12.64,0,0,1-.32,2.88,10.56,10.56,0,0,1-.9,2.48,8.66,8.66,0,0,1-1.38,2,7.42,7.42,0,0,1-1.76,1.43,4.15,4.15,0,0,1-1.78.61,1.87,1.87,0,0,1-1.37-.4,3,3,0,0,1-.89-1.45,8.42,8.42,0,0,1-.32-2.51v-8.81a1.07,1.07,0,0,1,.12-.48.64.64,0,0,1,.27-.34l1.88-1.08a.2.2,0,0,1,.27,0,.45.45,0,0,1,.11.35v8.72a2.89,2.89,0,0,0,.43,1.83c.28.33.71.34,1.28,0a3,3,0,0,0,1.28-1.5,5.88,5.88,0,0,0,.43-2.31v-8.72a1.05,1.05,0,0,1,.11-.48.75.75,0,0,1,.27-.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.65,163.59a3.74,3.74,0,0,1,1.68-.56,2.38,2.38,0,0,1,1.33.28,2.19,2.19,0,0,1,.87.91,2.81,2.81,0,0,1,.33,1.29.92.92,0,0,1-.09.39.61.61,0,0,1-.21.27l-1.88,1.08a.53.53,0,0,1-.32.1.63.63,0,0,1-.25-.12l-.14-.15a.72.72,0,0,0-.26-.16.85.85,0,0,0-.43,0,1.8,1.8,0,0,0-.63.24,4.8,4.8,0,0,0-.52.36,3.07,3.07,0,0,0-.45.43,2,2,0,0,0-.31.53,1.59,1.59,0,0,0-.12.62.66.66,0,0,0,.13.47.6.6,0,0,0,.46.14,3.48,3.48,0,0,0,.85-.12c.36-.09.8-.2,1.32-.35a4.25,4.25,0,0,1,1.38-.17,1.61,1.61,0,0,1,1,.37,2,2,0,0,1,.59,1,6.1,6.1,0,0,1,.19,1.69,7.47,7.47,0,0,1-.33,2.2,9.12,9.12,0,0,1-.92,2,9.3,9.3,0,0,1-1.41,1.77,8.52,8.52,0,0,1-1.77,1.36,4.5,4.5,0,0,1-1.78.63,2.46,2.46,0,0,1-1.38-.25,2.2,2.2,0,0,1-.91-.95,3.17,3.17,0,0,1-.34-1.45,1,1,0,0,1,.09-.4.52.52,0,0,1,.21-.26l1.87-1.08a.57.57,0,0,1,.32-.11.46.46,0,0,1,.23.1,1.92,1.92,0,0,1,.17.19,1.09,1.09,0,0,0,.31.23,1,1,0,0,0,.49.08,1.81,1.81,0,0,0,.72-.26,5.43,5.43,0,0,0,1.27-1,1.73,1.73,0,0,0,.51-1.21.46.46,0,0,0-.19-.44.9.9,0,0,0-.56-.09,5.08,5.08,0,0,0-1,.19l-1.37.35a2.08,2.08,0,0,1-2.16-.38,4,4,0,0,1-.68-2.64,7.74,7.74,0,0,1,.28-2,9.45,9.45,0,0,1,.81-2A9,9,0,0,1,74,165,7,7,0,0,1,75.65,163.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.76,168.16a.21.21,0,0,1,.28,0,.49.49,0,0,1,.11.35v2.34a1.2,1.2,0,0,1-.11.48.7.7,0,0,1-.28.34L82,175.61a.21.21,0,0,1-.27,0,.45.45,0,0,1-.12-.35V161a1.07,1.07,0,0,1,.12-.48.68.68,0,0,1,.27-.34l6.68-3.85a.2.2,0,0,1,.27,0,.45.45,0,0,1,.12.35V159a1.07,1.07,0,0,1-.12.48.75.75,0,0,1-.27.34l-4.42,2.55v2.38l4.1-2.37a.22.22,0,0,1,.28,0,.51.51,0,0,1,.11.35v2.34a1.21,1.21,0,0,1-.11.49.72.72,0,0,1-.28.33l-4.1,2.37v2.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.07,152.6a5.18,5.18,0,0,1,1.69-.67,1.83,1.83,0,0,1,1.27.2,2,2,0,0,1,.8,1.11,6.33,6.33,0,0,1,.28,2.08,9.74,9.74,0,0,1-.44,3,8.07,8.07,0,0,1-1.26,2.4l1.77,4.22a.63.63,0,0,1,0,.22,1,1,0,0,1-.1.4.56.56,0,0,1-.22.27L97,167c-.19.11-.33.13-.41,0a1.07,1.07,0,0,1-.19-.28l-1.59-3.81-1.32.76v4.73a1.2,1.2,0,0,1-.11.48.72.72,0,0,1-.28.33l-1.88,1.09a.21.21,0,0,1-.27,0,.49.49,0,0,1-.11-.35V155.66a1.2,1.2,0,0,1,.11-.48.81.81,0,0,1,.27-.34Zm-1.62,7.62,1.62-.93a3,3,0,0,0,1-.93,2.59,2.59,0,0,0,.4-1.51c0-.62-.13-1-.4-1a1.24,1.24,0,0,0-1,.22l-1.62.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.49,146.94a3.74,3.74,0,0,1,1.68-.56,2.49,2.49,0,0,1,1.33.28,2.25,2.25,0,0,1,.87.91,2.81,2.81,0,0,1,.33,1.29.92.92,0,0,1-.09.39.79.79,0,0,1-.21.27l-1.88,1.08a.53.53,0,0,1-.32.1.48.48,0,0,1-.25-.12l-.14-.14a.62.62,0,0,0-.26-.17,1,1,0,0,0-.43,0,1.67,1.67,0,0,0-.63.24,4.93,4.93,0,0,0-.53.36,3.58,3.58,0,0,0-.44.43,2,2,0,0,0-.32.53,1.59,1.59,0,0,0-.12.62.66.66,0,0,0,.14.47.59.59,0,0,0,.46.15,4.3,4.3,0,0,0,.85-.13l1.32-.34a4.49,4.49,0,0,1,1.37-.18,1.61,1.61,0,0,1,1,.37,1.93,1.93,0,0,1,.59,1,5.93,5.93,0,0,1,.2,1.68,7.47,7.47,0,0,1-.33,2.2,8.8,8.8,0,0,1-.93,2,9.48,9.48,0,0,1-1.4,1.77,8.83,8.83,0,0,1-1.77,1.35,4.56,4.56,0,0,1-1.78.63,2.43,2.43,0,0,1-1.38-.25,2.23,2.23,0,0,1-.91-.94,3.24,3.24,0,0,1-.35-1.46.88.88,0,0,1,.1-.4.63.63,0,0,1,.2-.26l1.88-1.08a.55.55,0,0,1,.32-.11.5.5,0,0,1,.23.1l.17.19a1,1,0,0,0,.31.23,1,1,0,0,0,.48.08,1.79,1.79,0,0,0,.73-.26,5.38,5.38,0,0,0,1.27-1,1.76,1.76,0,0,0,.5-1.21.47.47,0,0,0-.18-.44.92.92,0,0,0-.56-.09,4.93,4.93,0,0,0-1,.19c-.39.11-.85.22-1.37.35a2.07,2.07,0,0,1-2.16-.38,3.93,3.93,0,0,1-.68-2.64,7.32,7.32,0,0,1,.28-2,8.67,8.67,0,0,1,.81-2,9,9,0,0,1,1.28-1.79A6.88,6.88,0,0,1,104.49,146.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.85,87.88h-.08l-.79-.2a.52.52,0,0,1-.32-.26.49.49,0,0,1,0-.41l.58-1.43a.31.31,0,0,0-.07-.27,3,3,0,0,1-.22-.28s-.07-.08-.12,0l-1.07.66a.41.41,0,0,1-.64-.31L225,84.18a.87.87,0,0,1,.26-.71l1.08-.93a.7.7,0,0,0,.2-.38,7.72,7.72,0,0,1,.16-.78.16.16,0,0,0-.08-.18l-.61-.28a.57.57,0,0,1-.27-.3.53.53,0,0,1,0-.41l.77-1.58a.69.69,0,0,1,.66-.38l.76.06a.38.38,0,0,0,.29-.14,8.19,8.19,0,0,1,.59-.73.62.62,0,0,0,.14-.38l0-1.13a.91.91,0,0,1,.33-.68l1.22-.9a.42.42,0,0,1,.4-.07.41.41,0,0,1,.27.31l.24.89s.06,0,.08,0l.52-.15a.58.58,0,0,0,.32-.22l.78-1.39a.64.64,0,0,1,.7-.3l.79.2a.48.48,0,0,1,.32.25.49.49,0,0,1,0,.41l-.58,1.43a.31.31,0,0,0,.07.27,2.21,2.21,0,0,1,.22.29.09.09,0,0,0,.12,0l1.07-.66a.41.41,0,0,1,.41,0,.43.43,0,0,1,.23.34l.16,1.15a.86.86,0,0,1-.26.71l-1.08.93a.78.78,0,0,0-.2.38,7.9,7.9,0,0,1-.16.79.15.15,0,0,0,.08.17l.61.28a.53.53,0,0,1,.25.71L235,82.68a.72.72,0,0,1-.67.38l-.76-.06a.38.38,0,0,0-.29.14,8.45,8.45,0,0,1-.58.73.7.7,0,0,0-.15.39l0,1.13a1,1,0,0,1-.33.68l-1.21.89a.41.41,0,0,1-.68-.23l-.24-.9s-.06,0-.08,0a3.39,3.39,0,0,1-.52.15.58.58,0,0,0-.32.22l-.78,1.4A.67.67,0,0,1,227.85,87.88Zm-.94-3.35a.54.54,0,0,1,.4.25,1.3,1.3,0,0,0,.18.23.73.73,0,0,1,.14.73l-.57,1.43,0,.07.79.2a.2.2,0,0,0,.2-.09l.79-1.39a1,1,0,0,1,.6-.43c.15,0,.31-.08.47-.14a.49.49,0,0,1,.41,0,.45.45,0,0,1,.24.31l.25.89,1.2-.9a.46.46,0,0,0,.15-.31l0-1.13a1.06,1.06,0,0,1,.26-.69,7.72,7.72,0,0,0,.55-.7.86.86,0,0,1,.69-.32l.76.06a.26.26,0,0,0,.23-.13l.76-1.58a.09.09,0,0,0,0-.07l0,0-.61-.28a.61.61,0,0,1-.31-.68c.06-.25.11-.5.15-.74a1.17,1.17,0,0,1,.34-.65l1.08-.93a.47.47,0,0,0,.12-.32h0L236,76l-1,.67a.52.52,0,0,1-.72-.17,1,1,0,0,0-.18-.23.77.77,0,0,1-.14-.74l.57-1.43,0,0-.05,0-.79-.2a.2.2,0,0,0-.2.09l-.79,1.4a1,1,0,0,1-.6.43,3.1,3.1,0,0,0-.47.14.53.53,0,0,1-.41,0,.49.49,0,0,1-.24-.32l-.24-.89-1.21.9a.51.51,0,0,0-.15.31l0,1.13a1.06,1.06,0,0,1-.26.69c-.19.22-.38.46-.55.7a.84.84,0,0,1-.69.32l-.76-.06a.28.28,0,0,0-.23.13l-.76,1.59s0,0,0,.06a.08.08,0,0,0,.05,0l.61.28a.61.61,0,0,1,.32.69,5.11,5.11,0,0,0-.15.74,1.16,1.16,0,0,1-.35.64l-1.08.94a.45.45,0,0,0-.12.31l.17,1.15,1-.67A.52.52,0,0,1,226.91,84.53Zm2.58-.64a1.44,1.44,0,0,1-.42-.11,1.57,1.57,0,0,1-.91-1.33A5.31,5.31,0,0,1,230.28,78a2.27,2.27,0,0,1,2.16-.5,1.58,1.58,0,0,1,.91,1.34,5.32,5.32,0,0,1-2.12,4.42h0A2.63,2.63,0,0,1,229.49,83.89Zm2.48-6a2.16,2.16,0,0,0-1.43.52,4.82,4.82,0,0,0-1.95,4,1.17,1.17,0,0,0,.65,1,1.85,1.85,0,0,0,1.73-.45h0a4.81,4.81,0,0,0,1.95-4,1.16,1.16,0,0,0-.65-1A1,1,0,0,0,232,77.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.74,90.2A3.48,3.48,0,0,0,208.27,93c0,1.08.65,1.58,1.47,1.11a3.53,3.53,0,0,0,1.47-2.81C211.21,90.22,210.55,89.73,209.74,90.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,87.13a3.53,3.53,0,0,0-1.47,2.81c0,1.09.66,1.58,1.47,1.12a3.53,3.53,0,0,0,1.47-2.81C216.5,87.16,215.84,86.67,215,87.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.32,84.07a3.53,3.53,0,0,0-1.47,2.81c0,1.09.66,1.58,1.47,1.11a3.48,3.48,0,0,0,1.47-2.81C221.79,84.1,221.14,83.6,220.32,84.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.63,194.83h0a4.55,4.55,0,0,1,2.28.58c1.68,1,2.61,3.11,2.61,6,0,6.41-4.52,14.24-10.07,17.44a8.73,8.73,0,0,1-4.24,1.32,4.48,4.48,0,0,1-2.27-.58c-1.69-1-2.62-3.11-2.62-6,0-6.41,4.52-14.24,10.07-17.44a8.76,8.76,0,0,1,4.24-1.32m0-.94a9.52,9.52,0,0,0-4.71,1.44c-5.82,3.36-10.54,11.54-10.54,18.26,0,3.36,1.18,5.73,3.09,6.83a5.42,5.42,0,0,0,2.74.7,9.52,9.52,0,0,0,4.71-1.44c5.82-3.36,10.54-11.54,10.54-18.26,0-3.36-1.18-5.73-3.08-6.83a5.46,5.46,0,0,0-2.75-.7Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.78,207.64a2.69,2.69,0,0,0,4.41,2.54,9.74,9.74,0,0,0,4.41-7.63A2.69,2.69,0,0,0,79.19,200,9.75,9.75,0,0,0,74.78,207.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,209.62a3.08,3.08,0,0,0-3.12.25l-6.22,3.59c-2.08,1.2-3.88,4-4.53,6.95.07,0,.12.09.18.13a6.58,6.58,0,0,0,5.76.07l3.4-2a23.16,23.16,0,0,0,5.93-7.05A3.21,3.21,0,0,0,85,209.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.28,95.09v39.77l-177,101.91V197l177-101.91m.94-1.63-178.87,103v42l178.87-103V93.46Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.48,192.07v.75c0,.65.46.92,1,.59l34.32-19.68a2.24,2.24,0,0,0,1-1.76v-.75c0-.65-.46-.92-1-.6L95.51,190.31A2.23,2.23,0,0,0,94.48,192.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,200.55a.47.47,0,0,1-.24-.88l28.82-16.52a.47.47,0,0,1,.64.17.48.48,0,0,1-.17.65L95.24,200.49A.46.46,0,0,1,95,200.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,204.42a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.64L114.88,192a.47.47,0,0,1,.47.82L95.24,204.36A.46.46,0,0,1,95,204.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,131.08a.47.47,0,0,1-.23-.88l28.81-16.52a.46.46,0,0,1,.64.17.47.47,0,0,1-.17.64L203.06,131A.53.53,0,0,1,202.82,131.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,135a.49.49,0,0,1-.41-.24.48.48,0,0,1,.18-.65l20.1-11.53a.48.48,0,0,1,.65.18.47.47,0,0,1-.18.64l-20.1,11.53A.44.44,0,0,1,202.82,135Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,139.34a.47.47,0,0,1-.23-.88l28.81-16.52a.47.47,0,0,1,.64.17.48.48,0,0,1-.17.65l-28.81,16.52A.53.53,0,0,1,202.82,139.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,143.21a.49.49,0,0,1-.41-.24.46.46,0,0,1,.18-.64l20.1-11.53a.47.47,0,0,1,.65.17.46.46,0,0,1-.18.64l-20.1,11.53A.44.44,0,0,1,202.82,143.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.82,189.21a.48.48,0,0,1-.47-.48v-29.9a.47.47,0,0,1,.94,0v29.9A.48.48,0,0,1,136.82,189.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,154.27a.47.47,0,0,1-.47-.47V123.89a.47.47,0,0,1,.94,0V153.8A.47.47,0,0,1,197.6,154.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.93,150.13l11.17-6.45c1-.56,1.74-.11,1.74,1v12.9a3.83,3.83,0,0,1-1.74,3L161.93,167c-1,.55-1.73.11-1.73-1v-12.9A3.81,3.81,0,0,1,161.93,150.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.52,152.34a5.4,5.4,0,0,0-2.26,4.32c0,1.66,1,2.42,2.26,1.7a5.42,5.42,0,0,0,2.25-4.31C169.77,152.39,168.76,151.63,167.52,152.34Zm0,5c-.81.46-1.47,0-1.47-1.11a3.51,3.51,0,0,1,1.47-2.8c.8-.47,1.46,0,1.46,1.11A3.53,3.53,0,0,1,167.52,157.31Zm2.34-7.14a1.27,1.27,0,0,0-.53,1c0,.38.24.56.53.39a1.24,1.24,0,0,0,.53-1C170.39,150.18,170.15,150,169.86,150.17Zm2,.25a4.22,4.22,0,0,0-.2-1.31,1.42,1.42,0,0,0-.51-.74,1.06,1.06,0,0,0-.78-.23,2.68,2.68,0,0,0-1.06.34c-.47.25-.62.33-1.81,1s-1.35.79-1.82,1.09a5.15,5.15,0,0,0-1.06.88,5,5,0,0,0-.78,1.13,5.49,5.49,0,0,0-.51,1.33,7,7,0,0,0-.2,1.54c0,.64,0,.84,0,2.43s0,1.79,0,2.4a4.28,4.28,0,0,0,.2,1.31,1.42,1.42,0,0,0,.51.74,1.11,1.11,0,0,0,.78.23,2.53,2.53,0,0,0,1.06-.35c.47-.24.62-.32,1.82-1s1.34-.78,1.81-1.08a4.92,4.92,0,0,0,1.06-.89,4.7,4.7,0,0,0,.78-1.12,5.49,5.49,0,0,0,.51-1.33,7,7,0,0,0,.2-1.54c0-.64,0-.84,0-2.43S171.91,151,171.88,150.42Zm-.79,5.24a5.36,5.36,0,0,1-.15,1.17,3.54,3.54,0,0,1-.33.87,3.49,3.49,0,0,1-.5.73,4.62,4.62,0,0,1-.82.67c-.46.29-.6.38-1.77,1.06s-1.32.75-1.78,1a2,2,0,0,1-.82.27.68.68,0,0,1-.5-.15.87.87,0,0,1-.33-.48,3.24,3.24,0,0,1-.15-1c0-.61,0-.79,0-2.36s0-1.75,0-2.38a5.36,5.36,0,0,1,.15-1.17,3.54,3.54,0,0,1,.33-.87,3.49,3.49,0,0,1,.5-.73,3.87,3.87,0,0,1,.82-.67c.46-.3.6-.38,1.78-1.06s1.31-.75,1.77-1a2,2,0,0,1,.82-.27.68.68,0,0,1,.5.15.87.87,0,0,1,.33.48,3.24,3.24,0,0,1,.15,1c0,.61,0,.79,0,2.35S171.11,155,171.09,155.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.39,155.32c0-1.1-.78-1.55-1.74-1l-11.17,6.45a3.82,3.82,0,0,0-1.73,3v12.91c0,1.1.77,1.55,1.73,1l11.17-6.45a3.85,3.85,0,0,0,1.74-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.59,173v-6.16l1.57-.9.29-2.76-1.86,1.08v-1.68a2.27,2.27,0,0,1,1.1-2l.84-.48v-2.21a10.17,10.17,0,0,0-1.5.69,5.55,5.55,0,0,0-2.54,4.95v2l-1.7,1V169l1.7-1v6.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.18,134.17c0-1.11-.78-1.56-1.74-1l-11.17,6.45a3.84,3.84,0,0,0-1.73,3v12.9c0,1.1.77,1.55,1.73,1l11.17-6.45a3.83,3.83,0,0,0,1.74-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.77,139.53c0-.06,0-.06,0,0a2.73,2.73,0,0,1-.31.14,1.45,1.45,0,0,1-1.75-1.25s0-.33,0-.48,0-.06,0,0l0,0-1.39.8c-.09.05-.08,0-.08.15v8c0,.1,0,.21,0,.31a3.31,3.31,0,0,1-.61,1.55,1.92,1.92,0,0,1-.95.77,1,1,0,0,1-.3,0h0l-.11,0c-.43-.15-.63-.58-.57-1.31a3.12,3.12,0,0,1,.86-1.91,1.65,1.65,0,0,1,.46-.36,1.21,1.21,0,0,1,.3-.11s0,0,.06-.08v-.06c0-.48,0-1.52,0-1.52v-.42s0,0,0,0a3.2,3.2,0,0,0-.57.31,4.47,4.47,0,0,0-.75.65,6.35,6.35,0,0,0-1,1.46,7,7,0,0,0-.6,1.49,6.37,6.37,0,0,0-.24,1.44,5.8,5.8,0,0,0,0,.59,4,4,0,0,0,.12.73,1.89,1.89,0,0,0,1,1.29.38.38,0,0,0,.15.05h0l.07,0a1.05,1.05,0,0,0,.24.06,2.39,2.39,0,0,0,1.63-.56,6.15,6.15,0,0,0,1.85-2.38,6.84,6.84,0,0,0,.68-2.87c0-1.34,0-2.67,0-4a.17.17,0,0,1,0-.1s0,0,.07,0a2.17,2.17,0,0,0,1.21,0,3.25,3.25,0,0,0,.76-.32c.09-.05.1-.06.1-.17C189.79,140.94,189.77,139.65,189.77,139.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.21,272.88a6.1,6.1,0,0,1-3.08-.8c-2.2-1.27-3.41-3.9-3.41-7.4,0-6.92,4.87-15.37,10.87-18.83,3-1.75,5.91-2,8.12-.74s3.42,3.9,3.42,7.4c0,6.92-4.88,15.37-10.88,18.84h0A10.3,10.3,0,0,1,74.21,272.88Zm9.42-27.24A9,9,0,0,0,79.25,247C73.62,250.25,69,258.18,69,264.68c0,3,1,5.23,2.76,6.26s4.19.76,6.79-.74C84.22,266.94,88.8,259,88.8,252.51c0-3-1-5.23-2.75-6.25A4.82,4.82,0,0,0,83.63,245.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.78,258.73a2.69,2.69,0,0,0,4.41,2.55,9.78,9.78,0,0,0,4.41-7.64,2.69,2.69,0,0,0-4.41-2.55A9.75,9.75,0,0,0,74.78,258.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,260.71a3.08,3.08,0,0,0-3.12.25l-6.22,3.59c-2.08,1.2-3.88,4-4.53,7l.18.12a6.58,6.58,0,0,0,5.76.07l3.4-2a23.16,23.16,0,0,0,5.93-7.05A3.21,3.21,0,0,0,85,260.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.28,146.19V186l-177,101.91V248.09l177-101.9m.94-1.64-178.87,103v41.94l178.87-103V144.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.48,243.16v.75c0,.66.46.92,1,.6l34.32-19.68a2.28,2.28,0,0,0,1-1.77v-.75c0-.65-.46-.92-1-.59L95.51,241.4A2.23,2.23,0,0,0,94.48,243.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,251.65a.49.49,0,0,1-.41-.24.48.48,0,0,1,.17-.65l28.82-16.52a.47.47,0,0,1,.64.18.47.47,0,0,1-.17.64L95.24,251.58A.48.48,0,0,1,95,251.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,255.51a.47.47,0,0,1-.41-.24.47.47,0,0,1,.17-.64l20.11-11.53a.47.47,0,0,1,.47.82L95.24,255.45A.46.46,0,0,1,95,255.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,182.17a.47.47,0,0,1-.23-.88l28.81-16.52a.47.47,0,0,1,.64.17.48.48,0,0,1-.17.65l-28.81,16.52A.53.53,0,0,1,202.82,182.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,186a.49.49,0,0,1-.41-.24.46.46,0,0,1,.18-.64l20.1-11.53a.47.47,0,0,1,.65.17.46.46,0,0,1-.18.64L203.06,186A.53.53,0,0,1,202.82,186Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,190.43a.47.47,0,0,1-.23-.88L231.4,173a.47.47,0,0,1,.64.17.48.48,0,0,1-.17.65l-28.81,16.52A.53.53,0,0,1,202.82,190.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,194.3a.49.49,0,0,1-.41-.24.47.47,0,0,1,.18-.64l20.1-11.53a.48.48,0,0,1,.65.17.48.48,0,0,1-.18.65l-20.1,11.53A.53.53,0,0,1,202.82,194.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.82,240.3a.47.47,0,0,1-.47-.47V209.92a.47.47,0,0,1,.94,0v29.91A.47.47,0,0,1,136.82,240.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,205.36a.47.47,0,0,1-.47-.47V175a.47.47,0,1,1,.94,0v29.9A.47.47,0,0,1,197.6,205.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.93,201.22l11.17-6.45c1-.55,1.74-.11,1.74,1v12.9a3.82,3.82,0,0,1-1.74,3l-11.17,6.45c-1,.56-1.73.11-1.73-1v-12.9A3.82,3.82,0,0,1,161.93,201.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.52,203.44a5.4,5.4,0,0,0-2.26,4.31c0,1.66,1,2.42,2.26,1.71a5.42,5.42,0,0,0,2.25-4.32C169.77,203.48,168.76,202.72,167.52,203.44Zm0,5c-.81.47-1.47,0-1.47-1.11a3.51,3.51,0,0,1,1.47-2.8c.8-.46,1.46,0,1.46,1.11A3.53,3.53,0,0,1,167.52,208.4Zm2.34-7.14a1.27,1.27,0,0,0-.53,1c0,.39.24.57.53.4a1.27,1.27,0,0,0,.53-1C170.39,201.27,170.15,201.09,169.86,201.26Zm2,.25a4.28,4.28,0,0,0-.2-1.31,1.42,1.42,0,0,0-.51-.74,1.11,1.11,0,0,0-.78-.23,2.57,2.57,0,0,0-1.06.35c-.47.24-.62.32-1.81,1s-1.35.78-1.82,1.08a5.17,5.17,0,0,0-1.06.89,4.7,4.7,0,0,0-.78,1.12,5.49,5.49,0,0,0-.51,1.33,7,7,0,0,0-.2,1.54c0,.64,0,.84,0,2.43s0,1.79,0,2.4a4.22,4.22,0,0,0,.2,1.31,1.42,1.42,0,0,0,.51.74,1.06,1.06,0,0,0,.78.23,2.63,2.63,0,0,0,1.06-.34c.47-.25.62-.33,1.82-1s1.34-.79,1.81-1.09a4.9,4.9,0,0,0,1.06-.88,5,5,0,0,0,.78-1.13,5.49,5.49,0,0,0,.51-1.33,7,7,0,0,0,.2-1.54c0-.64,0-.84,0-2.43S171.91,202.12,171.88,201.51Zm-.79,5.24a5.36,5.36,0,0,1-.15,1.17,3.54,3.54,0,0,1-.33.87,3.49,3.49,0,0,1-.5.73,3.87,3.87,0,0,1-.82.67c-.46.3-.6.38-1.77,1.06s-1.32.75-1.78,1a2,2,0,0,1-.82.27.68.68,0,0,1-.5-.15.87.87,0,0,1-.33-.48,3.24,3.24,0,0,1-.15-1c0-.61,0-.79,0-2.35s0-1.76,0-2.39a5.36,5.36,0,0,1,.15-1.17,3.54,3.54,0,0,1,.33-.87,3.49,3.49,0,0,1,.5-.73,4.62,4.62,0,0,1,.82-.67c.46-.29.6-.38,1.78-1.06s1.31-.75,1.77-1a2,2,0,0,1,.82-.27.68.68,0,0,1,.5.15.87.87,0,0,1,.33.48,3.24,3.24,0,0,1,.15,1c0,.61,0,.79,0,2.36S171.11,206.12,171.09,206.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.39,206.41c0-1.1-.78-1.55-1.74-1l-11.17,6.45a3.84,3.84,0,0,0-1.73,3v12.9c0,1.1.77,1.55,1.73,1l11.17-6.45a3.83,3.83,0,0,0,1.74-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.59,224.09v-6.16l1.57-.91.29-2.76-1.86,1.08v-1.68a2.25,2.25,0,0,1,1.1-2l.84-.49v-2.21a9.66,9.66,0,0,0-1.5.7,5.52,5.52,0,0,0-2.54,5v2l-1.7,1v2.59l1.7-1v6.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.18,185.26c0-1.11-.78-1.56-1.74-1l-11.17,6.45a3.82,3.82,0,0,0-1.73,3v12.9c0,1.11.77,1.56,1.73,1l11.17-6.45a3.83,3.83,0,0,0,1.74-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,189.47c-.12-.55-.49-.83-.95-.72a33,33,0,0,0-4.23,2.14,39.9,39.9,0,0,0-4.23,2.74,3.48,3.48,0,0,0-1,1.83,28.2,28.2,0,0,0-.22,3.6,23,23,0,0,0,.22,3.34c.13.55.5.83,1,.72a33.72,33.72,0,0,0,4.23-2.14,41,41,0,0,0,4.23-2.74,3.4,3.4,0,0,0,.95-1.83,27,27,0,0,0,.23-3.6A22,22,0,0,0,191,189.47Zm-6.26,9.25V194.4l2.81.54Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.21,324a6.09,6.09,0,0,1-3.08-.79c-2.2-1.28-3.41-3.91-3.41-7.4,0-6.93,4.87-15.38,10.87-18.84,3-1.75,5.91-2,8.12-.74s3.42,3.9,3.42,7.4c0,6.93-4.88,15.38-10.88,18.84A10.2,10.2,0,0,1,74.21,324Zm9.42-27.24a9,9,0,0,0-4.38,1.36C73.62,301.34,69,309.27,69,315.78c0,3,1,5.22,2.76,6.25s4.19.76,6.79-.74h0C84.22,318,88.8,310.1,88.8,303.6c0-3-1-5.22-2.75-6.25A4.82,4.82,0,0,0,83.63,296.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.78,309.82a2.69,2.69,0,0,0,4.41,2.55,9.78,9.78,0,0,0,4.41-7.64,2.69,2.69,0,0,0-4.41-2.54A9.71,9.71,0,0,0,74.78,309.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,311.81a3,3,0,0,0-3.12.25l-6.22,3.58c-2.08,1.21-3.88,4-4.53,7l.18.12a6.54,6.54,0,0,0,5.76.07l3.4-2a23,23,0,0,0,5.93-7.05A3.16,3.16,0,0,0,85,311.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.28,197.28v39.77L61.29,339V299.18l177-101.9m.94-1.63-178.87,103v41.94l178.87-103V195.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.48,294.26V295c0,.65.46.91,1,.59l34.32-19.68a2.28,2.28,0,0,0,1-1.77v-.75c0-.65-.46-.92-1-.59L95.51,292.49A2.25,2.25,0,0,0,94.48,294.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,302.74a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.64l28.82-16.53a.47.47,0,0,1,.47.82L95.24,302.68A.46.46,0,0,1,95,302.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,306.6a.47.47,0,0,1-.24-.88l20.11-11.53a.48.48,0,0,1,.64.18.46.46,0,0,1-.17.64L95.24,306.54A.46.46,0,0,1,95,306.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,233.26a.47.47,0,0,1-.23-.88l28.81-16.52a.47.47,0,0,1,.64.17.48.48,0,0,1-.17.65L203.06,233.2A.53.53,0,0,1,202.82,233.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,237.13a.49.49,0,0,1-.41-.24.47.47,0,0,1,.18-.64l20.1-11.53a.48.48,0,0,1,.65.17.48.48,0,0,1-.18.65l-20.1,11.53A.53.53,0,0,1,202.82,237.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,241.53a.49.49,0,0,1-.41-.24.46.46,0,0,1,.18-.64l28.81-16.53a.47.47,0,0,1,.64.18.47.47,0,0,1-.17.64l-28.81,16.52A.44.44,0,0,1,202.82,241.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,245.39a.47.47,0,0,1-.23-.88L222.69,233a.48.48,0,0,1,.65.17.48.48,0,0,1-.18.65l-20.1,11.53A.53.53,0,0,1,202.82,245.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.82,291.39a.47.47,0,0,1-.47-.47V261a.47.47,0,0,1,.94,0v29.91A.47.47,0,0,1,136.82,291.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,256.45a.47.47,0,0,1-.47-.47v-29.9a.47.47,0,0,1,.94,0V256A.47.47,0,0,1,197.6,256.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.93,252.31l11.17-6.45c1-.55,1.74-.1,1.74,1v12.9a3.85,3.85,0,0,1-1.74,3l-11.17,6.45c-1,.55-1.73.1-1.73-1v-12.9A3.82,3.82,0,0,1,161.93,252.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.52,254.53a5.4,5.4,0,0,0-2.26,4.31c0,1.66,1,2.43,2.26,1.71a5.42,5.42,0,0,0,2.25-4.31C169.77,254.57,168.76,253.81,167.52,254.53Zm0,5c-.81.47-1.47,0-1.47-1.11a3.5,3.5,0,0,1,1.47-2.79c.8-.47,1.46,0,1.46,1.1A3.53,3.53,0,0,1,167.52,259.49Zm2.34-7.14a1.27,1.27,0,0,0-.53,1c0,.39.24.57.53.4a1.27,1.27,0,0,0,.53-1C170.39,252.36,170.15,252.19,169.86,252.35Zm2,.25a4.2,4.2,0,0,0-.2-1.3,1.49,1.49,0,0,0-.51-.75,1.16,1.16,0,0,0-.78-.23,2.73,2.73,0,0,0-1.06.35c-.47.24-.62.32-1.81,1s-1.35.78-1.82,1.08a5.22,5.22,0,0,0-1.84,2,5.49,5.49,0,0,0-.51,1.33,7,7,0,0,0-.2,1.54c0,.64,0,.84,0,2.44s0,1.78,0,2.4a4.2,4.2,0,0,0,.2,1.3,1.49,1.49,0,0,0,.51.75,1.1,1.1,0,0,0,.78.22,2.48,2.48,0,0,0,1.06-.34c.47-.24.62-.32,1.82-1s1.34-.78,1.81-1.08a5.22,5.22,0,0,0,1.06-.89,5,5,0,0,0,.78-1.13,5.34,5.34,0,0,0,.51-1.33,6.87,6.87,0,0,0,.2-1.54c0-.63,0-.84,0-2.43S171.91,253.21,171.88,252.6Zm-.79,5.24a5.48,5.48,0,0,1-.15,1.18,3.33,3.33,0,0,1-.33.86,3.24,3.24,0,0,1-.5.73,3.87,3.87,0,0,1-.82.67c-.46.3-.6.38-1.77,1.06s-1.32.75-1.78,1a2,2,0,0,1-.82.27.72.72,0,0,1-.5-.14.93.93,0,0,1-.33-.49,3.24,3.24,0,0,1-.15-1c0-.6,0-.79,0-2.35s0-1.75,0-2.38a5.38,5.38,0,0,1,.15-1.18,3.33,3.33,0,0,1,.33-.86,3,3,0,0,1,.5-.73,4.17,4.17,0,0,1,.82-.68c.46-.29.6-.38,1.78-1.06s1.31-.75,1.77-1a2,2,0,0,1,.82-.27.68.68,0,0,1,.5.15.94.94,0,0,1,.33.48,3.39,3.39,0,0,1,.15,1c0,.6,0,.78,0,2.35S171.11,257.21,171.09,257.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.39,257.51c0-1.11-.78-1.56-1.74-1L143.48,263a3.81,3.81,0,0,0-1.73,3v12.9c0,1.11.77,1.55,1.73,1l11.17-6.45a3.83,3.83,0,0,0,1.74-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--logo--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.07,261.42c-2.91,1.68-5.17,5.82-5.17,9.66,0,2,.62,3.39,1.63,4a.4.4,0,0,1,.14.31l0,1.21c0,.39.31.47.58.16l1-1.2a.52.52,0,0,1,.27-.19,4.91,4.91,0,0,0,1.5-.59c2.91-1.68,5.16-5.83,5.16-9.66S152,259.74,149.07,261.42Zm3.1,3.35-1.52,4.08c-.24.65-.76,1.08-1.12.92l-1.2-.51c-.11,0-.27.05-.38.22l-1.63,2.59c-.21.35-.5.16-.35-.23l1.51-4.08c.25-.65.76-1.08,1.12-.93l1.21.51c.11.05.26,0,.37-.21l1.63-2.59C152,264.19,152.32,264.37,152.17,264.77Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.18,236.35c0-1.11-.78-1.55-1.74-1l-11.17,6.45a3.82,3.82,0,0,0-1.73,3v12.9c0,1.11.77,1.56,1.73,1l11.17-6.45a3.82,3.82,0,0,0,1.74-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.77,241.71c0-.05,0-.05,0,0a1.66,1.66,0,0,1-.31.14,1.44,1.44,0,0,1-1.75-1.24s0-.34,0-.48,0-.07,0,0l0,0-1.39.8c-.09.06-.08,0-.08.16v8c0,.1,0,.2,0,.31a3.31,3.31,0,0,1-.61,1.55,1.84,1.84,0,0,1-.95.76,1,1,0,0,1-.3.05l0,0-.11,0c-.43-.15-.63-.58-.57-1.3a3.12,3.12,0,0,1,.86-1.92,1.81,1.81,0,0,1,.46-.35.94.94,0,0,1,.3-.12s0,0,.06-.08v0c0-.48,0-1.53,0-1.53v-.41s0,0,0,0a3.2,3.2,0,0,0-.57.31,4.06,4.06,0,0,0-.75.65,6.51,6.51,0,0,0-1,1.45,6.91,6.91,0,0,0-.6,1.5,6.19,6.19,0,0,0-.24,1.44,5.8,5.8,0,0,0,0,.59,3.86,3.86,0,0,0,.12.72,1.87,1.87,0,0,0,1,1.29.27.27,0,0,0,.15.05h0l.07,0a.69.69,0,0,0,.24.05,2.38,2.38,0,0,0,1.63-.55,6.23,6.23,0,0,0,1.85-2.38,6.88,6.88,0,0,0,.68-2.88c0-1.34,0-2.67,0-4,0,0,0-.07,0-.1s0,0,.07,0a2.16,2.16,0,0,0,1.21,0,3.25,3.25,0,0,0,.76-.32c.09-.05.1-.06.1-.17C189.79,243.12,189.77,241.84,189.77,241.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.62,241.61h0c-1.1.64-2,0-2-1.51V62.58a4.77,4.77,0,0,1,2-3.81h0c1.11-.64,2,0,2,1.51V237.8A4.75,4.75,0,0,1,248.62,241.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.62,91h0c-.59.34-1.07,0-1.07-.8V62.49a2.55,2.55,0,0,1,1.07-2h0c.59-.34,1.07,0,1.07.8V89A2.55,2.55,0,0,1,248.62,91Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.83,61.36a1.23,1.23,0,0,0-.07-.39s0-.06,0-.09a1.06,1.06,0,0,0-.1-.37,1.67,1.67,0,0,0-.25-.54.55.55,0,0,0-.14-.23.88.88,0,0,0-.12-.15,1.48,1.48,0,0,0-.28-.28l0,0a1.58,1.58,0,0,0-.36-.2,3,3,0,0,0-2.85.36L129.15,200.22c-2.33,1.35-4.24,4.64-4.24,9.36V409.64a2.86,2.86,0,0,0,1.53,2.54l.18.13.22.12a1.55,1.55,0,0,0,.36.13,2.57,2.57,0,0,0,.55.06,2.64,2.64,0,0,0,1.4-.4l.11-.06h0l4-2.33L373.62,271.37a9.36,9.36,0,0,0,4.24-7.34V61.88A4.28,4.28,0,0,0,377.83,61.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5,60.08a1,1,0,0,1,.48.11l.08,0h0l.07.05,0,0,.1.14h0v0l.09.14a.56.56,0,0,1,.09.17l0,0,.11.34v0l0,0,0,.07a.53.53,0,0,1,0,.12,2.86,2.86,0,0,1,0,.42V264a8.19,8.19,0,0,1-3.63,6.29L132.71,408.77,128.77,411h0l-.11.07-.11.06a1.67,1.67,0,0,1-.74.24h-.06a1.16,1.16,0,0,1-.28,0l-.08,0-.12-.07-.09-.06-.07,0,0,0,0,0a1.66,1.66,0,0,1-.89-1.48V407.5h0V209.58c0-4.58,1.88-7.3,3.64-8.31L374.22,60.49a2.74,2.74,0,0,1,1.28-.41m0-1.21a3.81,3.81,0,0,0-1.88.57L129.15,200.22c-2.34,1.35-4.24,4.64-4.24,9.36V408.71h0v.93a2.86,2.86,0,0,0,1.53,2.54l.18.13.22.12a1.55,1.55,0,0,0,.36.13,2.57,2.57,0,0,0,.55.06h.06a2.72,2.72,0,0,0,1.34-.41l.11-.06h0l4-2.33L373.62,271.37a9.36,9.36,0,0,0,4.24-7.34V61.88a4.28,4.28,0,0,0,0-.52,1.23,1.23,0,0,0-.07-.39s0-.06,0-.09a1.06,1.06,0,0,0-.1-.37,1.67,1.67,0,0,0-.25-.54.55.55,0,0,0-.14-.23.88.88,0,0,0-.12-.15,1.48,1.48,0,0,0-.28-.28l0,0a1.58,1.58,0,0,0-.36-.2,2.22,2.22,0,0,0-1-.21Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.47,59.08a3,3,0,0,0-2.85.36L129.15,200.22a9.37,9.37,0,0,0-4.24,7.34v8.22l-5.41-3.17v-8.12a9.34,9.34,0,0,1,4.23-7.33L368.21,56.38a2.94,2.94,0,0,1,3.08-.25C372.05,56.59,375.57,58.6,376.47,59.08Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.85,61.86c0-2.68-1.9-3.76-4.23-2.42L129.15,200.22a9.37,9.37,0,0,0-4.24,7.34v8.22L377.85,70.13Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.62,59.44,129.15,200.22a8.76,8.76,0,0,0-3,3.14l-5.38-3.11a8.54,8.54,0,0,1,2.94-3.1L368.21,56.37a3,3,0,0,1,3.08-.25c.76.47,4.27,2.47,5.17,3A3.05,3.05,0,0,0,373.62,59.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.49,212.62v-8.14a8.66,8.66,0,0,1,1.29-4.23l5.39,3.1a8.62,8.62,0,0,0-1.26,4.21v8.22Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.46,71.79a4.31,4.31,0,0,0-1.8,3.44c0,1.32.8,1.93,1.8,1.36a4.3,4.3,0,0,0,1.79-3.44C361.25,71.83,360.45,71.22,359.46,71.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.93,68.05a4.31,4.31,0,0,0-1.8,3.44c0,1.32.81,1.93,1.8,1.36a4.34,4.34,0,0,0,1.8-3.44C367.73,68.09,366.92,67.48,365.93,68.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.4,64.31a4.3,4.3,0,0,0-1.79,3.43c0,1.33.8,1.94,1.79,1.36a4.28,4.28,0,0,0,1.8-3.43C374.2,64.34,373.4,63.73,372.4,64.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.43,412.2l-.22-.12-4.46-2.59a4.47,4.47,0,0,1-2.21-3.28,4.32,4.32,0,0,1-.05-.62v-193l5.42,3.17V409.63a2.77,2.77,0,0,0,1.32,2.41.51.51,0,0,0,.13.09l0,0Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.43,412.2l-.22-.12-4.46-2.59a4.47,4.47,0,0,1-2.21-3.28,4.32,4.32,0,0,1-.05-.62v-193l5.42,3.17V409.63a2.77,2.77,0,0,0,1.32,2.41.51.51,0,0,0,.13.09l0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.6,220c0,10.84-3.77,22.83-9.88,33.49q-1.46,2.55-3.09,5c-1.08,1.61-2.22,3.17-3.39,4.69-1.05,1.34-2.12,2.64-3.23,3.89-.52.59-1.07,1.18-1.6,1.74a58.82,58.82,0,0,1-13,10.49,38.49,38.49,0,0,1-7.13,3.26c-.8.26-1.59.49-2.36.67a20.63,20.63,0,0,1-12.21-.37c-7.65-2.83-12.52-11-12.53-23.31,0-21.83,15.33-48.38,34.23-59.28S209.6,198.19,209.6,220Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.41,230.93c-1,3.92-.48,8,.15,12s1.37,8,.95,12c-.09.8-.16,1.74.45,2.25a1.59,1.59,0,0,0,2-.19,4.58,4.58,0,0,0,1.09-1.84l.72,8.66a5.16,5.16,0,0,0,.81,2.82c1,1.26,2.95,1.27,4.49.77,3.65-1.18,6.33-4.52,7.48-8.19a24.17,24.17,0,0,0,.26-11.41,47.09,47.09,0,0,0-5.32-14.72c-1.39-2.48-3-4.86-3.93-7.56a8.44,8.44,0,0,0-1.33-3c-.37-.43-.7-.29-1.18-.1a10.58,10.58,0,0,0-1.34.69,10.81,10.81,0,0,0-2.3,2,13.56,13.56,0,0,0-1.75,2.55,14,14,0,0,0-1.13,2.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.72,253.51q-1.46,2.55-3.09,5c-1.08,1.61-2.22,3.17-3.39,4.69l-3.05-8.76h0C194.31,253.17,197,252.53,199.72,253.51Z",
    style: {
      fill: "#ffbda7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.44,257.11q-1.63,2.42-3.4,4.69-1.56,2-3.23,3.89c-.52.58-1.07,1.17-1.6,1.74a58.77,58.77,0,0,1-13,10.49,38.86,38.86,0,0,1-7.14,3.26c-.79.26-1.59.49-2.36.67A39.16,39.16,0,0,0,162,265.71s2.84-1.51,8.26-4.47l.18-.12c4.32-3,7.23-2.43,15.17-5.83.13-.07-1-.64-.83-.69L190,253h0A59.33,59.33,0,0,1,196.44,257.11Z",
    style: {
      fill: "#1473E6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170,252.12c-.64-2.42-3.64-4.17-6.47-8.36s-6.48-13.62-.71-18c-1.06-5.64,3.46-12.58,9.63-15.35,8.12-3.65,17.61-3.15,23.1,3.8,6.5,8.21-.21,16-.21,16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.54,243.18a11.21,11.21,0,0,1-2.4,4.76c-1.4,1.68-3.34,2.58-6.54,3.68l.09,2.18.06,1.41.06,1.46.05,2.51s3.86,4.56,4.15,7.89c-.52.59-1.07,1.18-1.6,1.74A37.29,37.29,0,0,1,170.47,263v-.37l-.17-3.66-.4-8.94-.07-2.52a2.32,2.32,0,0,1-.41.95,3.58,3.58,0,0,1-1.33,1.1,3.85,3.85,0,0,1-3.25.18l-.24-.13a1.2,1.2,0,0,1-.34-.17,1.11,1.11,0,0,1-.27-.17.89.89,0,0,1-.22-.16h0a1.3,1.3,0,0,1-.23-.18,6.47,6.47,0,0,1-1.93-7.46c.8-1.89,3-3.57,4.56-2.93s1.83,1.66,2.54,2.8,4-2.36,1.73-8.3c2.72-2.15,4-7.15,3.29-9.55,1.18-4.32,9.2-4.86,10.61-3.23,1.17-2.72,1-4.37,3.31-3.66s6.09,2.21,7.43,11.62A39.34,39.34,0,0,1,194.54,243.18Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.39,242.3l4.79.13a3.15,3.15,0,0,1-3.13,2.78C180.74,245.11,180.16,243.89,180.39,242.3Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,244.92a2.08,2.08,0,0,0-2.8-1.71l-.23.11a1.84,1.84,0,0,0,1.68,1.89A2.64,2.64,0,0,0,183.4,244.92Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.85 229.7 185.95 239.05 190.43 236.01 184.85 229.7",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.7,230.15a1.24,1.24,0,0,0,1.52,1.32,2.08,2.08,0,0,0,1.56-1.94,1.24,1.24,0,0,0-1.51-1.32A2.09,2.09,0,0,0,189.7,230.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.61,233.91a1.24,1.24,0,0,0,1.52,1.32,2.09,2.09,0,0,0,1.56-1.94,1.24,1.24,0,0,0-1.51-1.32A2.09,2.09,0,0,0,178.61,233.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,251.62a21.28,21.28,0,0,1-9.54-.45,9.31,9.31,0,0,1-4.48-3.7s-.33,3,4.18,5.13c3.54,1.65,9.93,1.21,9.93,1.21Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.6,225.53l-3.41.22a2.78,2.78,0,0,1,2.23-2C192.37,223.68,192.9,224.48,192.6,225.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29,228.57l-3.72,2.48a2.64,2.64,0,0,1,1.27-2.81C179.87,227.56,181,227.7,181.29,228.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.64,216.23c.68,3.72-3.66,12.33-9.46,16.24s-9.54,3.16-9.54,3.16-.68-11.87,5.09-16.35S187.64,216.23,187.64,216.23Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.25,282.56c-.8.26-1.59.49-2.36.67a20.63,20.63,0,0,1-12.21-.37,13,13,0,0,1-3.79-3c4.19-9.93,6.41-11.81,12.11-14.16h0C165.88,268.54,167.61,278.19,168.25,282.56Z",
    style: {
      fill: "#ffbda7"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M190.67,197.48h0c10.51,0,17,8.64,17,22.54,0,10.16-3.42,21.71-9.64,32.55-.93,1.64-1.94,3.28-3,4.86s-2.18,3.11-3.33,4.59-2.11,2.63-3.15,3.79c-.51.58-1,1.15-1.55,1.7a57.2,57.2,0,0,1-12.6,10.15,37.74,37.74,0,0,1-6.78,3.11c-.76.25-1.5.46-2.22.62a22.26,22.26,0,0,1-5.35.69,16.31,16.31,0,0,1-5.75-1c-7.17-2.65-11.29-10.5-11.3-21.53,0-21.2,14.93-47.06,33.29-57.65,5-2.89,10-4.42,14.34-4.42m0-1.89c-4.6,0-9.79,1.5-15.29,4.68-18.9,10.9-34.23,37.45-34.23,59.28,0,12.3,4.88,20.48,12.53,23.31a18.28,18.28,0,0,0,6.41,1.11,24.15,24.15,0,0,0,5.8-.74c.77-.18,1.56-.41,2.36-.67a38.49,38.49,0,0,0,7.13-3.26,58.82,58.82,0,0,0,13-10.49c.53-.56,1.08-1.15,1.6-1.74,1.11-1.25,2.18-2.55,3.23-3.89,1.17-1.52,2.31-3.08,3.39-4.69s2.12-3.28,3.09-5c6.11-10.66,9.88-22.65,9.88-33.49,0-15.48-7.71-24.43-18.93-24.43Z",
    style: {
      fill: "#1473E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.38,350.2a.94.94,0,0,1-.94-.94V169.7a.94.94,0,0,1,1.88,0V349.26A.94.94,0,0,1,222.38,350.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.33,310.36v1.41c0,1.22.86,1.72,1.92,1.11l54.25-31.1a4.22,4.22,0,0,0,1.92-3.31v-1.41c0-1.22-.86-1.72-1.92-1.11l-54.25,31.1A4.22,4.22,0,0,0,146.33,310.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,315.9a.94.94,0,0,1-.47-1.76l36.75-21.08a.95.95,0,1,1,.94,1.64l-36.75,21.07A.9.9,0,0,1,157,315.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.81,334a.95.95,0,0,1-.47-1.77l36.76-21.07a.94.94,0,1,1,.94,1.63l-36.76,21.08A.9.9,0,0,1,161.81,334Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.38,354a.94.94,0,0,1-.47-1.76l50-28.68a.95.95,0,0,1,.94,1.64l-50,28.67A.84.84,0,0,1,150.38,354Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.38,361.53a.94.94,0,0,1-.47-1.76l50-28.68a.95.95,0,0,1,.94,1.64l-50,28.67A.84.84,0,0,1,150.38,361.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.38,369.05a.94.94,0,0,1-.47-1.76l50-28.68a.95.95,0,1,1,.94,1.64l-50,28.68A1,1,0,0,1,150.38,369.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.38,376.57a.94.94,0,0,1-.47-1.76l50-28.67a.94.94,0,1,1,.94,1.63l-50,28.68A1,1,0,0,1,150.38,376.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,331.26c0-3-2-4.26-4.38-2.86a10,10,0,0,0-4.38,7.92V337c0,2.29,2.6,4.95,3.79,6.06a.59.59,0,0,0,.93-.18c1-2.11,4-8.47,4-10.93ZM152.65,336c-1.21.7-2.19.13-2.19-1.26a4.82,4.82,0,0,1,2.19-3.79c1.21-.7,2.19-.14,2.19,1.26A4.83,4.83,0,0,1,152.65,336Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.92,210.75a.94.94,0,0,1-.47-1.76L366.8,132.51a.95.95,0,1,1,.94,1.64L234.39,210.62A.9.9,0,0,1,233.92,210.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.92,302.94a.93.93,0,0,1-.82-.48,1,1,0,0,1,.35-1.29L366.8,224.7a.95.95,0,1,1,.94,1.64L234.39,302.81A.9.9,0,0,1,233.92,302.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.37,276.68l-6.18,3.56a1.71,1.71,0,0,0-.7,1.35v.14c0,.51.32.75.7.53l6.18-3.56a1.72,1.72,0,0,0,.7-1.35v-.14C250.07,276.69,249.75,276.45,249.37,276.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.76,268.94l-6.17,3.56a1.69,1.69,0,0,0-.7,1.35V274c0,.52.31.76.7.53l6.17-3.56a1.7,1.7,0,0,0,.71-1.35v-.14C263.47,269,263.15,268.72,262.76,268.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.16,261.2,270,264.77a1.66,1.66,0,0,0-.7,1.34v.14c0,.52.31.76.7.53l6.17-3.56a1.68,1.68,0,0,0,.71-1.34v-.14C276.87,261.22,276.55,261,276.16,261.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.56,253.47,283.39,257a1.68,1.68,0,0,0-.7,1.34v.14c0,.52.31.76.7.54l6.17-3.57a1.67,1.67,0,0,0,.71-1.34V254C290.27,253.48,290,253.24,289.56,253.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,245.73l-6.17,3.56a1.69,1.69,0,0,0-.7,1.35v.14c0,.52.31.76.7.53l6.17-3.56a1.7,1.7,0,0,0,.71-1.35v-.14C303.67,245.74,303.35,245.5,303,245.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.36,238l-6.17,3.57a1.66,1.66,0,0,0-.7,1.34V243c0,.52.31.76.7.53l6.17-3.56a1.68,1.68,0,0,0,.7-1.35v-.14C317.06,238,316.75,237.77,316.36,238Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.76,230.26l-6.17,3.56a1.68,1.68,0,0,0-.71,1.34v.14c0,.52.32.76.71.54l6.17-3.57a1.66,1.66,0,0,0,.7-1.34v-.14C330.46,230.27,330.15,230,329.76,230.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.16,222.52,337,226.08a1.7,1.7,0,0,0-.71,1.35v.14c0,.52.32.75.71.53l6.17-3.56a1.69,1.69,0,0,0,.7-1.35v-.14C343.86,222.53,343.55,222.29,343.16,222.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.56,214.78l-6.17,3.56a1.7,1.7,0,0,0-.71,1.35v.14c0,.52.32.76.71.53l6.17-3.56a1.68,1.68,0,0,0,.7-1.35v-.14C357.26,214.8,357,214.56,356.56,214.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.26 258.45 249.85 254.07 249.85 266.54 242.26 270.93 242.26 258.45",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.66 237.86 263.25 233.48 263.25 258.81 255.66 263.19 255.66 237.86",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.66 237.86 263.25 233.48 263.25 258.81 255.66 263.19 255.66 237.86",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.05 214.09 276.64 209.71 276.64 251.08 269.05 255.46 269.05 214.09",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.05 214.09 276.64 209.71 276.64 251.08 269.05 255.46 269.05 214.09",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.44 228.75 290.03 224.37 290.03 243.34 282.44 247.72 282.44 228.75",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.44 228.75 290.03 224.37 290.03 243.34 282.44 247.72 282.44 228.75",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.84 216.81 303.43 212.42 303.43 235.61 295.84 239.99 295.84 216.81",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.84 216.81 303.43 212.42 303.43 235.61 295.84 239.99 295.84 216.81",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.23 201.91 316.82 197.53 316.82 227.88 309.23 232.26 309.23 201.91",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.63 210.5 330.22 206.11 330.22 220.14 322.63 224.53 322.63 210.5",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.63 210.5 330.22 206.11 330.22 220.14 322.63 224.53 322.63 210.5",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.02 198.29 343.61 193.91 343.61 212.41 336.02 216.79 336.02 198.29",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.02 198.29 343.61 193.91 343.61 212.41 336.02 216.79 336.02 198.29",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.42 187.59 357 183.2 357 204.68 349.42 209.06 349.42 187.59",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.87,166.9c-8.39,17.76-19.48,22.94-26.42,22a23.81,23.81,0,0,1-6.07-1.79c-3.29-1.34-5.89-2.4-11.35.75-3.51,2-6.41,5.76-9.23,9.37-3.64,4.68-7.09,9.11-11.29,8.7-2.95-.28-5-2.43-7-4.5-3.09-3.21-6.29-6.52-12.64-2.85-10.62,6.12-22.76,29.37-31,46.32l.78.79c8.07-16.67,20-39.5,30.2-45.4,5.87-3.39,8.77-.39,11.83,2.79,2.08,2.15,4.23,4.38,7.38,4.69,4.66.44,8.33-4.26,12.21-9.25,2.7-3.47,5.5-7.06,8.76-8.94,5.14-3,7.49-2,10.75-.68a23.93,23.93,0,0,0,6.2,1.83c7.27,1,18.88-4.43,27.68-23.05Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.87,166.9c-8.39,17.76-19.48,22.94-26.42,22a23.81,23.81,0,0,1-6.07-1.79c-3.29-1.34-5.89-2.4-11.35.75-3.51,2-6.41,5.76-9.23,9.37-3.64,4.68-7.09,9.11-11.29,8.7-2.95-.28-5-2.43-7-4.5-3.09-3.21-6.29-6.52-12.64-2.85-10.62,6.12-22.76,29.37-31,46.32l.78.79c8.07-16.67,20-39.5,30.2-45.4,5.87-3.39,8.77-.39,11.83,2.79,2.08,2.15,4.23,4.38,7.38,4.69,4.66.44,8.33-4.26,12.21-9.25,2.7-3.47,5.5-7.06,8.76-8.94,5.14-3,7.49-2,10.75-.68a23.93,23.93,0,0,0,6.2,1.83c7.27,1,18.88-4.43,27.68-23.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.88,295.69a.93.93,0,0,1-.82-.48.94.94,0,0,1,.35-1.29L309,274.08a.94.94,0,1,1,.93,1.63l-34.61,19.85A.87.87,0,0,1,274.88,295.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.88,303.31a.94.94,0,0,1-.47-1.76L309,281.7a.94.94,0,1,1,.93,1.63l-34.61,19.85A.87.87,0,0,1,274.88,303.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.88,310.93a.94.94,0,0,1-.47-1.76L309,289.32A.94.94,0,0,1,310,291L275.34,310.8A.87.87,0,0,1,274.88,310.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.68,309.15l32.66-18.86c.42-.25.76-.05.76.43v29.5a1.67,1.67,0,0,1-.76,1.31l-32.66,18.86c-.42.24-.76.05-.76-.44V310.46A1.67,1.67,0,0,1,234.68,309.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.3,318.93l2.58,3.63-11.67-10.62-12.29,20.83V340c0,.49.34.68.76.44l32.66-18.86a1.67,1.67,0,0,0,.76-1.31v-4L259.4,310Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.71,301.47c1.52-.88,2.75-.17,2.75,1.59a6.1,6.1,0,0,1-2.75,4.78c-1.53.88-2.76.16-2.76-1.6A6.08,6.08,0,0,1,256.71,301.47Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.38,249a1,1,0,0,1-.82-.48,1,1,0,0,1,.36-1.29L366.8,241a.95.95,0,1,1,.94,1.64l-10.89,6.2A.9.9,0,0,1,356.38,249Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.38,256.57a.95.95,0,0,1-.46-1.77l10.88-6.2a.95.95,0,0,1,.94,1.64l-10.89,6.2A.9.9,0,0,1,356.38,256.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.38,264.19a1,1,0,0,1-.82-.48.94.94,0,0,1,.36-1.28l10.88-6.21a1,1,0,0,1,1.29.36.94.94,0,0,1-.35,1.28l-10.89,6.21A1,1,0,0,1,356.38,264.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.19,262.41l32.66-18.87c.42-.24.76,0,.76.44v29.49a1.67,1.67,0,0,1-.76,1.32l-32.66,18.86c-.42.24-.76.05-.76-.44V263.72A1.67,1.67,0,0,1,316.19,262.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.81,272.19l2.58,3.63L327.72,265.2,315.43,286v7.18c0,.49.34.68.76.44l32.66-18.86a1.67,1.67,0,0,0,.76-1.32v-3.94l-8.7-6.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.21,254.73c1.53-.88,2.76-.17,2.76,1.59a6.08,6.08,0,0,1-2.76,4.78c-1.52.88-2.75.16-2.75-1.6A6.1,6.1,0,0,1,338.21,254.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.11,390.59s-6-21.32-.1-44.3c3.29-12.84,10.86-19.38,15.79-20.41,5.53-1.15,11.7,3.59,7.54,12.25-3.95,8.23-12.75,12.27-16.11,33.07a88.07,88.07,0,0,0-1.11,19.38,1.77,1.77,0,0,1-2.55,1.71Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.11,390.59s-6-21.32-.1-44.3c3.29-12.84,10.86-19.38,15.79-20.41,5.53-1.15,11.7,3.59,7.54,12.25-3.95,8.23-12.75,12.27-16.11,33.07a88.07,88.07,0,0,0-1.11,19.38,1.77,1.77,0,0,1-2.55,1.71Z",
    style: {
      fill: "green",
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.1,385.5a.37.37,0,0,0,.28-.42c-4.83-24.57,5.09-46.47,13.69-54.18a.36.36,0,0,0,0-.5.35.35,0,0,0-.49,0c-8.72,7.82-18.79,30-13.91,54.84A.36.36,0,0,0,457.1,385.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.13,392.55a1.77,1.77,0,0,0,2.55-1.31c.81-5.07,3.47-10.45,8.77-16.35,6.17-6.86,14.92-13.43,13-18.83s-9.14-3.56-14-.06-15.39,16.1-11.2,36.11Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.13,392.55a1.77,1.77,0,0,0,2.55-1.31c.81-5.07,3.47-10.45,8.77-16.35,6.17-6.86,14.92-13.43,13-18.83s-9.14-3.56-14-.06-15.39,16.1-11.2,36.11Z",
    style: {
      fill: "green",
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.64,392.91a.34.34,0,0,0,.28-.35c-1.76-15.13,9.5-33.05,18.29-36.91a.35.35,0,0,0,.17-.47.36.36,0,0,0-.46-.17c-8.79,3.06-21.16,22.43-18.7,37.56a.38.38,0,0,0,.36.35Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-1--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.83,432.78c-8-8.29-12.76-29.25-4.92-35.83h39.9c7.84,6.58,3.12,27.53-4.91,35.83l-.22.23-.28.27c-.23.22-.47.44-.72.65l-.2.16c-.19.15-.39.31-.6.46s-.69.47-1,.67c-6.62,3.86-17.34,3.86-24,0h0a11,11,0,0,1-1-.68c-.2-.14-.38-.28-.56-.43l-.24-.19a8.47,8.47,0,0,1-.7-.63L65,433Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.35,394.3c9.1,5.31,9.1,13.93,0,19.25s-23.87,5.31-33,0-9.1-13.94,0-19.25S87.24,389,96.35,394.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,396.85c6.68,3.91,6.68,10.24,0,14.14s-17.53,3.9-24.21,0-6.69-10.23,0-14.14S85.28,393,92,396.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,403.56c6.68-3.9,17.52-3.9,24.21,0a11.16,11.16,0,0,1,4,3.72A11.23,11.23,0,0,1,92,411c-6.69,3.9-17.53,3.9-24.21,0a11.27,11.27,0,0,1-4-3.71A11.2,11.2,0,0,1,67.76,403.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,365.21c-2.69,3.4-10.78,4.9-14.81-3.44-3.79-7.81-7.79-15.19-9-18.08a3.05,3.05,0,0,1,1.65-4.08s-.1-4.44,7.63-2,13.37,6.58,17.21,13.7S79.35,363.84,74.4,365.21Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.4,365.21c-2.69,3.4-10.78,4.9-14.81-3.44-3.79-7.81-7.79-15.19-9-18.08a3.05,3.05,0,0,1,1.65-4.08s-.1-4.44,7.63-2,13.37,6.58,17.21,13.7S79.35,363.84,74.4,365.21Z",
    style: {
      fill: "green"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.52,376.32a39.4,39.4,0,0,0-1-4.43,63.11,63.11,0,0,0-3.14-8.46A64.37,64.37,0,0,0,64.46,348,55.79,55.79,0,0,0,57,340.81c-.08-.06-.13.11-.07.17a68.46,68.46,0,0,1,11.83,14,68.73,68.73,0,0,1,7.47,16.3c.49,1.6,1,3.21,1.39,4.84s.74,3.33,1.15,5c0,.17.31.25.3,0A31.87,31.87,0,0,0,78.52,376.32Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.52,376.32a39.4,39.4,0,0,0-1-4.43,63.11,63.11,0,0,0-3.14-8.46A64.37,64.37,0,0,0,64.46,348,55.79,55.79,0,0,0,57,340.81c-.08-.06-.13.11-.07.17a68.46,68.46,0,0,1,11.83,14,68.73,68.73,0,0,1,7.47,16.3c.49,1.6,1,3.21,1.39,4.84s.74,3.33,1.15,5c0,.17.31.25.3,0A31.87,31.87,0,0,0,78.52,376.32Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.17,359.24c-7,2.17-12.23-3.31-10.43-11.91S83.58,329.2,87,331.76c2.12-2.13,6.82-1.36,9,5.62S96.21,362.28,83.17,359.24Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.17,359.24c-7,2.17-12.23-3.31-10.43-11.91S83.58,329.2,87,331.76c2.12-2.13,6.82-1.36,9,5.62S96.21,362.28,83.17,359.24Z",
    style: {
      fill: "green"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.29,337a94.07,94.07,0,0,0-4.66,15.44,149.85,149.85,0,0,0-2.71,16.17c-1.26,10.5-1.48,9.92-1.41,20.48q0,4.4.11,8.77c.06,3,0,6,.27,9,.1,1.15,1.73.84,1.76-.21.1-5.26-.19-10.55-.24-15.81a34.14,34.14,0,0,1,.09-4.41,219.26,219.26,0,0,1,2.85-31.65c.5-2.91,1.05-5.82,1.73-8.7.72-3,1.59-6,2.39-9C87.5,337,87.36,336.83,87.29,337Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.29,337a94.07,94.07,0,0,0-4.66,15.44,149.85,149.85,0,0,0-2.71,16.17c-1.26,10.5-1.48,9.92-1.41,20.48q0,4.4.11,8.77c.06,3,0,6,.27,9,.1,1.15,1.73.84,1.76-.21.1-5.26-.19-10.55-.24-15.81a34.14,34.14,0,0,1,.09-4.41,219.26,219.26,0,0,1,2.85-31.65c.5-2.91,1.05-5.82,1.73-8.7.72-3,1.59-6,2.39-9C87.5,337,87.36,336.83,87.29,337Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.93,382.46C66,387,59.8,390.29,52.6,387.31s-21.38-21.68-14.9-23.74c-.35-3.39,19.25-6.18,28.94,5.77C73.69,378,66.93,382.46,66.93,382.46Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.93,382.46C66,387,59.8,390.29,52.6,387.31s-21.38-21.68-14.9-23.74c-.35-3.39,19.25-6.18,28.94,5.77C73.69,378,66.93,382.46,66.93,382.46Z",
    style: {
      fill: "green"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.21,389.21A32.89,32.89,0,0,0,74.29,386a88.2,88.2,0,0,0-6.61-5.91,89.5,89.5,0,0,0-15.17-9.76,79.39,79.39,0,0,0-9.16-4.16c-.09,0-.06.13,0,.16,2.61,1.24,5.24,2.44,7.77,3.85A88.56,88.56,0,0,1,58.73,375a110.06,110.06,0,0,1,13.4,11c1.18,1.14,2.31,2.33,3.5,3.46s2.58,2.24,3.77,3.46c.17.18.48.1.29-.16C78.85,391.55,78.09,390.35,77.21,389.21Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.21,389.21A32.89,32.89,0,0,0,74.29,386a88.2,88.2,0,0,0-6.61-5.91,89.5,89.5,0,0,0-15.17-9.76,79.39,79.39,0,0,0-9.16-4.16c-.09,0-.06.13,0,.16,2.61,1.24,5.24,2.44,7.77,3.85A88.56,88.56,0,0,1,58.73,375a110.06,110.06,0,0,1,13.4,11c1.18,1.14,2.31,2.33,3.5,3.46s2.58,2.24,3.77,3.46c.17.18.48.1.29-.16C78.85,391.55,78.09,390.35,77.21,389.21Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.75,377c-.12-2.56-13-2.42-19.06,2.44s-6.77,9.63-3,11.28c-.66,5.41,7.87,9,15.51,2.21S109.5,377.52,106.75,377Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.75,377c-.12-2.56-13-2.42-19.06,2.44s-6.77,9.63-3,11.28c-.66,5.41,7.87,9,15.51,2.21S109.5,377.52,106.75,377Z",
    style: {
      fill: "green",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,383.75A31.65,31.65,0,0,0,79.8,396.27c-.2.31.29.92.5.58a36.88,36.88,0,0,1,13.75-13S94.1,383.72,94,383.75Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,383.75A31.65,31.65,0,0,0,79.8,396.27c-.2.31.29.92.5.58a36.88,36.88,0,0,1,13.75-13S94.1,383.72,94,383.75Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.46,399c-4.36,4.3.46,9.61,7.55,12.24a25.35,25.35,0,0,0,18.33-.85c3.42-1.71,4.12-2.56,4.12-2.56a43.57,43.57,0,0,0-3.61-8.67A18.18,18.18,0,0,0,94,391C84.91,392.12,84.17,395.89,85.46,399Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.46,399c-4.36,4.3.46,9.61,7.55,12.24a25.35,25.35,0,0,0,18.33-.85c3.42-1.71,4.12-2.56,4.12-2.56a43.57,43.57,0,0,0-3.61-8.67A18.18,18.18,0,0,0,94,391C84.91,392.12,84.17,395.89,85.46,399Z",
    style: {
      fill: "green"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.79,402.24a45.08,45.08,0,0,0-11.1-4.11c-3.8-.74-8.47-.77-11.55,1.94-1.19,1.05-2.77,3.32-1.8,4.93.09.16.57.46.68.14a15.3,15.3,0,0,1,1-3,6.08,6.08,0,0,1,2.37-2.24,14.12,14.12,0,0,1,8-1.36c4.32.41,8.39,2.15,12.37,3.78C103.83,402.35,103.83,402.25,103.79,402.24Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.79,402.24a45.08,45.08,0,0,0-11.1-4.11c-3.8-.74-8.47-.77-11.55,1.94-1.19,1.05-2.77,3.32-1.8,4.93.09.16.57.46.68.14a15.3,15.3,0,0,1,1-3,6.08,6.08,0,0,1,2.37-2.24,14.12,14.12,0,0,1,8-1.36c4.32.41,8.39,2.15,12.37,3.78C103.83,402.35,103.83,402.25,103.79,402.24Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.66,372c-1.09,3.84,3.81,7.42,9.9,5.37s12.42-4,17.61-4,8.49-3.48,7.42-5.79-2.33-7.77-15.56-9.33-19.2,3.11-22,6.76S84.46,372.63,86.66,372Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.66,372c-1.09,3.84,3.81,7.42,9.9,5.37s12.42-4,17.61-4,8.49-3.48,7.42-5.79-2.33-7.77-15.56-9.33-19.2,3.11-22,6.76S84.46,372.63,86.66,372Z",
    style: {
      fill: "green"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.25,363.92a16.11,16.11,0,0,0-4.27-.39,26.05,26.05,0,0,0-4.13.34,32.12,32.12,0,0,0-7.77,2.41c-4.65,2.07-9.27,4.76-12.29,9a29.39,29.39,0,0,0-3.89,7.29c-.18.49.78.77,1,.33a53.74,53.74,0,0,1,3.31-6.34,19.46,19.46,0,0,1,5.07-5.28,40.28,40.28,0,0,1,14-6.43,28.14,28.14,0,0,1,4.48-.66,42.12,42.12,0,0,1,4.49.17C111.48,364.32,111.39,364,111.25,363.92Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.25,363.92a16.11,16.11,0,0,0-4.27-.39,26.05,26.05,0,0,0-4.13.34,32.12,32.12,0,0,0-7.77,2.41c-4.65,2.07-9.27,4.76-12.29,9a29.39,29.39,0,0,0-3.89,7.29c-.18.49.78.77,1,.33a53.74,53.74,0,0,1,3.31-6.34,19.46,19.46,0,0,1,5.07-5.28,40.28,40.28,0,0,1,14-6.43,28.14,28.14,0,0,1,4.48-.66,42.12,42.12,0,0,1,4.49.17C111.48,364.32,111.39,364,111.25,363.92Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.81,393.61c-1-3.94-6-6.16-12.57-6.65A17.11,17.11,0,0,0,47,395.31c-3.42,5.85-4.84,10.5-2.77,11.27s10.87,2,16.54,2.48,12.75-.51,17.37-4.82S81.22,394.52,75.81,393.61Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.81,393.61c-1-3.94-6-6.16-12.57-6.65A17.11,17.11,0,0,0,47,395.31c-3.42,5.85-4.84,10.5-2.77,11.27s10.87,2,16.54,2.48,12.75-.51,17.37-4.82S81.22,394.52,75.81,393.61Z",
    style: {
      fill: "green",
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.06,393.09a17.32,17.32,0,0,0-7.06-.33,31.06,31.06,0,0,0-6.67,1.54,42,42,0,0,0-6.6,3c-1.11.6-2.2,1.25-3.26,1.93a23.45,23.45,0,0,0-2.93,2s0,.16,0,.13c1.07-.48,2.08-1.16,3.1-1.73s2.22-1.23,3.36-1.81A46.47,46.47,0,0,1,62.58,395a31,31,0,0,1,6.93-1.49,43,43,0,0,1,6.62.17C76.59,393.75,76.33,393.18,76.06,393.09Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.06,393.09a17.32,17.32,0,0,0-7.06-.33,31.06,31.06,0,0,0-6.67,1.54,42,42,0,0,0-6.6,3c-1.11.6-2.2,1.25-3.26,1.93a23.45,23.45,0,0,0-2.93,2s0,.16,0,.13c1.07-.48,2.08-1.16,3.1-1.73s2.22-1.23,3.36-1.81A46.47,46.47,0,0,1,62.58,395a31,31,0,0,1,6.93-1.49,43,43,0,0,1,6.62.17C76.59,393.75,76.33,393.18,76.06,393.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "409.24 404.14 406.35 402.91 409.08 401.98 409.24 404.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.66,410.93S414,394,414.51,396.22a3.3,3.3,0,0,1,.06,1.35s.06-.08.08-.12l-.37,4.23a9.9,9.9,0,0,1-5,2.46c0-.2-.11-1.45-.16-2.16a16.52,16.52,0,0,0-2.84,1.73c-2,1.53-3.27,4.08-5.36,7.08-1.53,2.19-4.4,3.34-8.71,4.2-4.64.93-8.8.27-10-.93A3.36,3.36,0,0,1,381.66,410.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.52,409.91c.3-.35,1.41-1.73,2.93-3.25,1.33-1.32,2.87-3,4.55-4.37a41.35,41.35,0,0,0,3.8-4.15,35.92,35.92,0,0,0,4.07-6.83c.46-1.17.79-2.55.51-6.86-.38-6-.62-7.37-.9-11.95l16.75-1.11c-.32,2.56-1,6.16-1.39,9.63-.45,4.39-1.87,4.88.08,9.17a13,13,0,0,1,1.54,3.83c.23,2.24-1.42,4.28-3.31,5.48-1.58,1-3.43,1.5-4.95,2.56a16.49,16.49,0,0,0-3.89,4.31c-1,1.5-1.84,3.25-3.35,4.35a14.4,14.4,0,0,1-5.29,2.18,28.45,28.45,0,0,1-7.24.78C383,413.61,380.34,412.49,382.52,409.91Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09,402.5a6.22,6.22,0,0,0-5.17-.18c-2.34,2.08-4.26,3.93-5.62,5.22-1.65,1.56-3.1,3-2.94,4.67.25,2.63,10.48,2.85,16,0a7.12,7.12,0,0,0,3.82-3.76S400.16,404.82,395.09,402.5Zm18.82-10.57c-1-1.65-1.34-2.5-1.34-2.5-1.92,1.2-5.08,6.36-3.22,11.27a7.55,7.55,0,0,0,4.8-3.69A4.78,4.78,0,0,0,413.91,391.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,393.47c-.84,1.51.78,8.94.87,12.78.08,3.5.09,9.76,1.51,13.08,1.69,3.94,4.83,8.4,9.67,4.1,3-2.67,4.58-5.9,4.61-10.94,0-3.51-1.85-8.17-3.48-12.32-1.89-4.84-2.67-7.45-2.67-7.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,369.1c1,8.07,1,12.69,1.39,17.89a68,68,0,0,0,1.27,8.07c.71,3.32,2.12,7.76,2.82,9.86,1,2.93,1.67,4.77.83,8.24a4,4,0,0,1-.31.79c-1.33,2.93-5.12,5.4-6.41,5.18a2.32,2.32,0,0,1-2.17.94L447,420a3.6,3.6,0,0,1-.44-.12,4.08,4.08,0,0,1-2.31-2.35c-.09-.22-.18-.46-.26-.72a27,27,0,0,1-1.24-8.4c-.06-1.9-.35-5.2-.77-8.22s-2.7-11.3-4-15.84c-1-3.75-3.06-11.46-3.06-11.46Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.57,408.75c-3.22-1-12.51-.14-13.63,4.09.28,3.87.69,6.33,3.58,9.43,3.83,4.13,8-1,9.5-4.2A14.63,14.63,0,0,0,456.57,408.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.52,262.43c3.25,7.94,6.33,16.68,6.83,33.5.67,22.17,1.71,30.18,1.93,32.85.37,4.55,2.33,8.68,4.44,21.75s1,37.07,1,37.07a15.66,15.66,0,0,1-8.1,3.77c-4.61.68-6.64-1.13-6.64-1.13s-8.78-35.38-11-43.2-8.81-33.57-8.81-33.57l-2.61,21.65s2.61,6.82,1.85,18.43-4.86,33.36-4.86,33.36-2.46,1.88-7.45,1.63-7-2-7-2-4.47-43.11-5.21-56.18-2.58-47.48,2.19-68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.68,283.64c2.28,5.28,9.67,8.65,12.86,9.23l4.88,20.41-.85,21.84,2.61-21.65-5.57-24.9S403.83,288.44,398.68,283.64Zm29.75-4.34c.64,2.09,1.23,4.2,1.85,6.3s1.22,4.22,1.87,6.34a44.11,44.11,0,0,0-.81-6.59c-.41-2.17-.95-4.32-1.57-6.45a59.06,59.06,0,0,0-2.26-6.25,30.62,30.62,0,0,0-3.18-5.84c.78,2.08,1.49,4.14,2.17,6.22S427.82,277.2,428.43,279.3Zm3.48-4.3c.79,1.24,1.54,2.5,2.29,3.76l2.24,3.84a17.63,17.63,0,0,0-1.26-4.33,29.15,29.15,0,0,0-2.08-4,32.86,32.86,0,0,0-2.65-3.64,23.31,23.31,0,0,0-3.18-3.18c.73,1.32,1.52,2.57,2.3,3.82S431.15,273.75,431.91,275Zm.12,59.88c-1.64-6.7-2.93-13.49-4.21-20.29S425.32,301,424,294.17c.82,6.88,1.71,13.75,2.78,20.6s2.29,13.68,3.93,20.44,3.44,13.42,5.25,20.11,3.67,13.36,5.63,20q-2.16-10.17-4.57-20.28C435.39,348.32,433.71,341.57,432,334.88ZM397.69,314l.32-18.09c-.67,6-1.12,12-1.41,18.06s-.51,12.05-.26,18.15c.48,6.06,1.21,12,2,18s1.63,12,2.61,17.92q-.66-9-1.53-18l-.86-9c-.28-3-.6-6-.8-9s-.14-6-.13-9S397.66,317,397.69,314Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.58,193.05c-.86-.39-1.22.43-.81,1.2,1,1.81,3.47,2.27,4.49,3.17.23.25,2.83,4,2.72,4.88-.83-.61-3.29-2.75-4.16-3.32a32.2,32.2,0,0,0-3.27-1.45,3.32,3.32,0,0,0-1.23-.39c-.3,0-.73.56-.34,1.28.7,1.28,2.42,1.62,3.62,2.44.6.38,2.41,1.71,2.72,3.13-1.84-1-3.12-1.21-6.19-1.6-.36,0-.46.12-.5.35a1.24,1.24,0,0,0,.47,1.06c.74.63,2,.72,3.27,1.19a8.75,8.75,0,0,1,3.36,2.52,3.79,3.79,0,0,1,.77,1.35,17.94,17.94,0,0,1,.37,1.94,6.56,6.56,0,0,0,5.36,5,.85.85,0,0,0,.5,0,.92.92,0,0,0,.43-.75c.54-2.92-.28-5.88-.71-8.81-.14-1-1.35-8.19-1.44-8.45s-6.55-3.49-6.76-3.56C342.6,194,341.4,193.43,340.58,193.05Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.49,219.55c-2.37.63-20.92,5.69-20.92,5.69s-12-9.77-14.38-12c-3.3-3.12-3.87-6.14-4.39-8.78-.76-3.79-1.26-4.09-2.66-5.53-.87-.89-2.74-3.28-2.81-3.37a3.45,3.45,0,0,0-1.09-.7L347,194.2c-1.2-.59-2-.88-3.18-1.47a6,6,0,0,0-1.15-.46.46.46,0,0,0-.26,0c-.16.06-.21.26-.21.43a3,3,0,0,0,1,2.13,10.18,10.18,0,0,0,2,1.32c.44.24.7.34,1.58.84a2.23,2.23,0,0,1,.82.88,26.89,26.89,0,0,1,2.7,5.18,9.69,9.69,0,0,1-3.82-3.41c-.86-1.37-2.23-.15-1.59,1.88.74,2.35,2.49,3,3.4,6.17s-2,5.33,1.12,8.39a32.1,32.1,0,0,1,5.05,5c2.52,3.39,10.37,13.91,12.19,15.77,4,4,4.57,3.82,15.63,1.29,15.61-3.56,18.4-4.54,18.4-4.54l7.48-16.36C404.08,217.17,402.48,217.42,394.49,219.55Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.27,216.42c-2,.09-2.54.16-10.4,2.14s-24.17,6.36-24.17,6.36l-4.08-3.34a10.11,10.11,0,0,1-2.85,5.11,18,18,0,0,1-5.43,3.79l3.44,4.39c3.2,4.07,4.88,4.83,6.12,5.32s3-.05,6.44-.71S401.23,234,401.23,234Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.32,203.05a11.17,11.17,0,0,1,2.26,2.07c.24.32.35-.61-.7-1.85s-2.13-1.39-2.32-1.89Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.47,181.06a4.46,4.46,0,0,0,1.11-4.56c-1.1-3.42-4.82-4.58-8-3.81a8,8,0,0,0-3.09-2.89,5.19,5.19,0,0,0-4.15-.26,3.84,3.84,0,0,0-2.46,3.23,2.57,2.57,0,0,1-1.06-2,4.37,4.37,0,0,0-1.42,2.72,18.46,18.46,0,0,0-16.13.93c-3.59,1.88-7.27,4.57-8.68,8.55-1.48,4.15,0,9.32,2.94,12.45a31.46,31.46,0,0,0,4.29,3.6l6.26,4.66a36.48,36.48,0,0,1,3.62,2.93,18.74,18.74,0,0,1,3.4,4.43c.19.34.43.74.82.78a1.16,1.16,0,0,0,.65-.18,33.34,33.34,0,0,0,9.59-6.91,20.93,20.93,0,0,0,5.19-9.44,19.89,19.89,0,0,0,.46-2.86h1a2.31,2.31,0,0,0,1.72-.58c.17-.15,1.19-1.52.81-1.73,1.63.94,3.66,1,4.63.15-.48-.13-2.63-.52-2.88-2a3.71,3.71,0,0,0,1.38-7.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.05,273.75c-1.8-7.61-4.12-12.42-4-14.08.57-7.21,3.13-16.56,4.05-20.71,2-9-2.16-17.48-4.16-19.42l-4.77-1.49c-1.56-.49-4.1-1-6.49-1.51-5.32-1.13-7.55-1.23-9.57-1.16-1,0-5.74.51-5.74.51-1.45.23-4.07.52-4.08.53a30.13,30.13,0,0,0-6.83,7.62c-2.6,4-4.16,7.35-5.19,16.17-1.3,11.24-2.89,23.81-3.44,31.68C401.79,278.28,430.51,279.94,443.05,273.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.18,213.79c.06-1.83.29-8.62.29-8.62,0,.56,2.92,2.83,5.69.25s3.3-5.62,2.08-7.74c-1.35-2.35-4.93-2.66-6.78.69-1.15,1.15-2.84-.55-1.6-3.88.08-2.43-3.07-5.45-.73-9.3-6.3-5.36-14.15-6-18.75-2.9a40.74,40.74,0,0,0-3.25,13c-.67,8,1,12,3.37,13.67,1.59,1.1,3.11,1.5,6.1,1.61,0,0-.07,2-.09,3.19s-.55,1.45-1.81,1.71c-.85.18-3,.55-3,.55s-3.25,4.29,4.46,5.67c12.3,2.21,18-3.61,18-3.61s-.51-.21-2.42-.83C430,216.65,430.12,215.61,430.18,213.79Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.6,210.54c5.39.1,10.69-1,12.18-3.32a4.84,4.84,0,0,1-2.61,3.66c-3.24,1.42-9.63,1.54-9.63,1.54Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.19,201.46l-4.86.93a2.42,2.42,0,0,0,2.84,2A2.59,2.59,0,0,0,420.19,201.46Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.76,202.5a2.73,2.73,0,0,0-3,1.79,2.35,2.35,0,0,0,1.37.14,2.54,2.54,0,0,0,1.95-1.84C420,202.56,419.89,202.52,419.76,202.5Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.1,187.87l3.35-.42a1.62,1.62,0,0,0-1.82-1.49A1.78,1.78,0,0,0,411.1,187.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.74,188.91l-3.27-1a1.64,1.64,0,0,1,2.08-1.16A1.79,1.79,0,0,1,424.74,188.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.25,193.85a1.3,1.3,0,1,0,1.31-1.27A1.29,1.29,0,0,0,420.25,193.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.72,192.84a1.3,1.3,0,1,0,1.31-1.28A1.29,1.29,0,0,0,409.72,192.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.31,190.43l7.88,5.61a3.45,3.45,0,0,0-2.69.26l-5.68-4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,189.77c.48,1.07.18,2.92.62,4.14.38,2.41,4.45,4.21,6.93,2.12a5.14,5.14,0,0,0,1-1.25c.69-1.18.75-2.94,1.67-3,2.54,0-.37,6.34,6.48,6.73,3.32.24,4.32-2.83,4.93-5.32.23-.72.83-.79,1-1.69s-.55-1.26-1.27-1.36a21.33,21.33,0,0,0-6.7-.75c-2.13.33-2.92.91-4.07.76s-1.7-.91-3.58-1.76a18.68,18.68,0,0,0-6.68-1C405.31,187.48,405.57,189.24,406,189.77Zm13,1.43c1.62-1.48,6.51-1,7.42.21.49.71-.15,2.92-.56,3.94,0,.12-.11.24-.18.37a3.24,3.24,0,0,1-3.56,1.74,3.8,3.8,0,0,1-2.69-1.43,5.42,5.42,0,0,1-.43-4.83Zm-8.81-2.62c3.73.81,5.11,1.86,3.57,5.52-.59,1.76-3.29,2.42-5,1.27a4.22,4.22,0,0,1-1.59-3.25C406.87,189,407.13,188.22,410.23,188.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.74,197.08l4.18,2.64,1.54-6.74a2.08,2.08,0,0,0-.42-.92Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.36,220.17c6.41,2.6,7.88,8.87,4.33,15.9-3.12,6.16-15.45,21.3-17.4,23.77s-3.54,3.3-8.45,5.21-17.9,5.49-21.69,6.62-6.23,3.26-9.84,4.83-8.53,1.35-11,.88a5.85,5.85,0,0,1-3.1-2.31c-1.72-.49-1.94-1.2-1.81-1.8-1.53-.25-2.18-.66-1.59-1.71,1.24-2.19,5.37-1.77,9.15-2.52,3.62-.73,6.48-2.23,5.58-2.72-1.83-1-4.88.12-7.63-1.52-1.62-1-1.31-2.39-.53-2.36,1.44.07,4.29-.81,7.83-.89,3.22-.07,7.23,1.28,9.59.37,5.55-2.12,22.21-10.3,22.21-10.3L429,231S432.9,222.43,439.36,220.17Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.2,254.44l5.61-3.09,13.42-20.51s5.12-10,10.73-11.31c5,2.1,6.14,4.26,6.79,6.69.41,1.52.74,6.43-3.71,13.75s-13.56,17.59-15.52,20.1-2.2,2.74-5.78,4.07-6.23,2.08-6.23,2.08C411,263.06,409,259.26,409.2,254.44Z",
    style: {
      fill: "#37474f"
    }
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNouser);
export default __webpack_public_path__ + "static/media/nouser.0b1c5926fb98d1307ab2f43322b5785f.svg";
export { ForwardRef as ReactComponent };